export default __webpack_public_path__ + "static/ShoppersDrugMart-709ad0f4e6e07c8d13040953c82c2e41.png";